import { RadioGroupColorType } from '../types';

export const RADIO_GROUP_COLORS_MAP: Record<RadioGroupColorType, string> = {
  primary: 'radio--primary',
  orange: 'radio--orange',
  green: 'radio--green',
  red: 'radio--red',
};
